import * as React from "react"
import type { SVGProps } from "react"
const SvgPersonRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m20 10.93-1.4 1.37a1 1 0 0 1-.69.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.27-.7q0-.42.27-.7l1.38-1.4-1.38-1.37a1 1 0 0 1-.28-.7q0-.4.28-.7.3-.3.71-.3.42 0 .72.3L20 8.1l1.38-1.4a1 1 0 0 1 .68-.3q.42 0 .72.3t.3.71-.3.71L21.4 9.5l1.4 1.4q.3.3.29.7a1 1 0 0 1-.32.7q-.3.27-.7.29a1 1 0 0 1-.7-.29zM9.5 12q-1.65 0-2.82-1.17Q5.5 9.65 5.5 8c0-1.65.4-2.04 1.18-2.82Q7.85 4 9.5 4c1.65 0 2.04.4 2.83 1.18Q13.5 6.35 13.5 8c0 1.65-.4 2.04-1.17 2.83A4 4 0 0 1 9.5 12m-8 6v-.8q0-.86.44-1.56.44-.72 1.16-1.09a15 15 0 0 1 3.15-1.16A14 14 0 0 1 9.5 13a14 14 0 0 1 6.4 1.55q.72.37 1.16 1.09.45.71.44 1.56v.8q0 .83-.59 1.41a2 2 0 0 1-1.41.59h-12q-.82 0-1.41-.59A2 2 0 0 1 1.5 18m2 0h12v-.8a1 1 0 0 0-.5-.85q-1.35-.68-2.72-1.01a11.6 11.6 0 0 0-5.55 0q-1.38.33-2.73 1.01a1 1 0 0 0-.5.85zm6-8q.82 0 1.41-.59.6-.58.59-1.41 0-.82-.59-1.41A2 2 0 0 0 9.5 6q-.82 0-1.41.59A2 2 0 0 0 7.5 8q0 .82.59 1.41.58.6 1.41.59" />
  </svg>
)
export default SvgPersonRemove
